module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a246880e69bc7a2a793c90a2fb013ae1.svg";